import { IItemByValue } from '../pages/Dashboard/ItemByValueDashboardChart';
import { IInventoryReportType } from '../sp-types/InventoryReportType';
import { DEFAULT_COLOR, IInventoryProduct } from '../sp-types/InventoryType';
import { Material } from '../sp-types/materialType';
import { dateToMonthYear, sortMonthYear } from './MonthYear/monthYear';

export const getLastMaterialDate = (pastProducts: IInventoryProduct[]): IInventoryProduct => {
  const sortedPrducts = pastProducts.sort((a, b) => sortMonthYear(a.date, b.date));

  return sortedPrducts[sortedPrducts.length];
};

export const groupByMaterial = (inventoryReports: IInventoryReportType[]): Record<string, IInventoryReportType[]> =>
  inventoryReports.reduce(
    (acc, material) => ({ ...acc, [material.formulaId]: [...acc[material.formulaId], material] }),
    {} as Record<string, IInventoryReportType[]>,
  );

export const sumInvReports = (
  inventoryReports: IInventoryReportType[],
  pricesMap: Record<string, number>,
  getCurrencyInUSD: (_currency: string) => number,
): Record<string, { quantity: number; actualPriceSum: number }> =>
  inventoryReports
    .filter(({ ratio }) => !ratio || ratio === 0)
    .reduce(
      (acc, { formulaId, actualPrice, quantity, currency }) => ({
        ...acc,
        [formulaId]: {
          quantity: (acc[formulaId]?.quantity || 0) + quantity,
          actualPriceSum:
            (acc[formulaId]?.actualPriceSum || 0) +
            ((actualPrice || 0) * getCurrencyInUSD(currency || '') || pricesMap[formulaId]) * quantity,
        },
      }),
      {} as Record<string, { quantity: number; actualPriceSum: number }>,
    );

export const fixMonthYear = (material: IInventoryReportType): IInventoryReportType => {
  material.monthYear = dateToMonthYear(material.reportingTime.toDate());
  return material;
};

export const getItemByValueData = (
  inventoryReports: IInventoryReportType[],
  materialMap: Record<string, Material>,
  pricesMap: Record<string, number>,
  colorDictionary: Record<string, string>,
): IItemByValue[] => {
  const lastMaterialReports = groupByMaterial(inventoryReports);

  return Object.values(lastMaterialReports)
    .map((a) => a[0]) // this is quick fix. the sceen wont work
    .map(({ formulaId, quantity }) => ({
      color: colorDictionary[formulaId] || DEFAULT_COLOR,
      item: materialMap[formulaId]?.name || formulaId,
      value: pricesMap[formulaId] * quantity,
    }));
};
